import color from "../../../../constants/color";

const styles = {

  TableHead: {
    color: "#878787",
    width: "33.33%",
    fontWeight: "400",
  },
  
  leaveHeading: { 
    fontWeight: 600,
    fontSize: "20px", 
  },
  lightText: {
    color:color?.lightText,
    fontSize: "14px",
  },
  lightTexts: {
    color:color?.lightText,
    fontSize: "12px",
    fontWeight: "500",
    cursor:"pointer",
  },

  dataName: {
    fontSize: "14px",
    textTransform:"capitalize"

  },
  tabledata: {
    borderBottom: 0,
    width: "33.33%"
  },
  tableAvtardata: {
    borderBottom: 0, 
    display: "flex", 
    alignItems: "center",
    fontSize: "12px",
    width: "33.33%",
  },
  tableAvtardatas: {
    borderBottom: 0, 
    display: "flex", 
    alignItems: "center",
    fontSize: "12px",
  },

  tableActiondata: {
    borderBottom: 0, 
    display: "flex", 
    alignItems: "center", 
    justifyContent: "space-around", 
  }
}
export default styles
  